function SequencingObjective (Id, SatisfiedByMeasure, MinNormalizedMeasure, Maps) {
    this.Id = Id;
    this.SatisfiedByMeasure = SatisfiedByMeasure;
    this.MinNormalizedMeasure = MinNormalizedMeasure;
    this.Maps = Maps;
}

SequencingObjective.prototype.toString = function () {
    var ret = "Id=" + this.Id + ", SatisfiedByMeasure=" + this.SatisfiedByMeasure + ", MinNormalizedMeasure=" + this.MinNormalizedMeasure,
        map;

    ret += "Maps:";
    for (map in this.Maps) {
        if (this.Maps.hasOwnProperty(map)) {
            ret += "{" + map + "}" + this.Maps[map] + "  ";
        }
    }

    return ret;
};
